/**
 * Пути уже загруженных фото (из API) → значение GalleryEditor
 */
export const galleryFromPaths = (paths = []) =>
  (paths || []).filter(Boolean).map((imgPath) => ({ key: imgPath, imgPath }));
